(function(){
  if (window.__dsq) return; window.__dsq = 1;
  function init(root){
    (root||document).querySelectorAll('[data-dsq-rail]').forEach(function(r){
      if (r.__i) return; r.__i = 1;
      var t = r.querySelector('[data-dsq-track]'); if(!t) return;
      function step(){ var c = t.querySelector('.dsq-card'); return c ? c.getBoundingClientRect().width + 24 : 300; }
      var p = r.querySelector('[data-dsq-prev]'), n = r.querySelector('[data-dsq-next]');
      p && p.addEventListener('click', function(){ t.scrollBy({left: -step(), behavior: 'smooth'}); });
      n && n.addEventListener('click', function(){ t.scrollBy({left: step(), behavior: 'smooth'}); });
    });
    var els = (root||document).querySelectorAll('[data-dsq-in]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: .15 });
    els.forEach(function(e){ io.observe(e); });
  }
  document.readyState !== 'loading' ? init() : document.addEventListener('DOMContentLoaded', function(){ init(); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
